// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"ca907ddb","487":"f8c198f9","707":"d09a191d"}[chunkId] + ".chunk.js";
};